export enum EmergencyIncidentId {
  MatchWillNotBeCovered = 2846,
  ProblemsWithSourceOfBroadcast = 2847,
  ProblemWithSourceOfBroadcastSolved = 2848,
  ScoutingCoverageCanStartWithDelay = 2852,
  ExpectedDelayInStartOfMatch = 2853,
  TeamLineupsWillNotBeAvailable = 2854,
  SourceOfCoverageDelayed = 2855,
  CurrentPartOfGameHasStartedWithDelay = 2856,
  VerificationOfResultInProgress = 2857,
  VerificationOfResultCompletedAndCorrect = 2858,
  VerificationOfKeyStatisticsInProgress = 2859,
  VerificationOfKeyStatisticsCompletedAndCorrect = 2860,
  VerificationOfGameClockInProgress = 2861,
  VerificationOfGameClockCompletedAndCorrect = 2862,
  MatchCoverageInterruptedDueToTechnicalIssues = 2863,
  MatchCoverageWillContinue = 2864,
  MatchCoverageWillNotContinue = 2865,
  MatchIsAbandoned = 2866,
  WaitingForOfficialDecisionRegardingMatchResumption = 2867,
  MatchWillResumeShortly = 2868,
  MatchWillNotResume = 2869,
  ExpectedDelayInStartOfNextPartOfGame = 2870,
  ChangeOfCoverageFromVenueToTv = 2871,
  ChangeOfCoverageFromTvToVenue = 2872,
  ChangeOfCoverageLatency = 2873,
  ExpectedDelayInStartOfMatchSafetyReasons = 2874,
  VerificationOfPlayerNamesForKeyIncidentsInProgress = 2877,
  VerificationOfPlayerNamesForKeyIncidentsCompletedAndCorrect = 2878,
  ProblemsWithLowLatencySourceOfCoverage = 2881,
  ProblemsWithLowLatencySourceOfCoverageSolved = 2882,
  PlayerNameVerificationInProgressSubstitution = 2883,
}
